module.exports = {
    //host:'https://connected24test.edialog24.com'
    host:''
}


// WEBPACK FOOTER //
// ./src/config.js